import request from '@/utils/request'
import host from '@/api/base/host'
// 用户登录
const account = host.path('dev', { dev: 'v1/account' })
export default {
  // 多账户查询
  AcountQuery(data) {
    return request({ url: account('query'), method: 'post', data })
  },
  // 合并
  AcountCombine(data) {
    return request({ url: account('combine'), method: 'post', data })
  }
}
